// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"SocialResponsibilityContactFormSection_formContainer__6RmgH"};